var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBase = function SvgBase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "base",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "baseShards"
  }, /*#__PURE__*/React.createElement("path", {
    "data-id": 0,
    className: "shard",
    d: "M826.74 196.361l-23.88 34.048 23.88-17.825z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 1,
    className: "shard",
    d: "M692.17 517.441l-23.877-23.999v58.049z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 2,
    className: "shard",
    d: "M-273.01 488.698l34.806 17.93h-34.806z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 3,
    className: "shard",
    d: "M-245.118 554.39l34.805 17.93v-17.93z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 4,
    className: "shard",
    d: "M511.401 733.37l23.88 25.325-23.88-6.071z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 5,
    className: "shard",
    d: "M118.821 761.378l23.88 23.998v-17.929z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 6,
    className: "shard",
    d: "M52.571 750.33l39.733 17.824H28.692z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 7,
    className: "shard",
    d: "M795.993 435.024l-39.73-17.824h39.732z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 8,
    className: "shard",
    d: "M325.92 776.615l-23.879-9.093 23.88 25.323z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 9,
    className: "shard",
    d: "M-246.022-98.65l63.612 18.032v-18.033z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 10,
    className: "shard",
    d: "M-130.674-167.117l23.88 9.096",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 11,
    className: "shard",
    d: "M110.795 806.67l-23.88-18.038v8.942z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 12,
    className: "shard",
    d: "M360.162 764.55l23.88 18.034h39.732z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 13,
    className: "shard",
    d: "M-148.526 603.49h32.863l-21.937 18.038z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 14,
    className: "shard",
    d: "M740.294 118.211l25.532 18.038 10.924-18.038z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 15,
    className: "shard",
    d: "M-234.546 42.924h22.58l-.638-18.037z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 16,
    className: "shard",
    d: "M776.348 394.973h-17.242l-8.286-18.037z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 17,
    className: "shard",
    d: "M-165.257-152.495l19.291 18.037-8.286-18.037z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 18,
    className: "shard",
    d: "M-93.668-211.538l18.652 68.207v-68.207z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 19,
    className: "shard",
    d: "M176.877 768.938l19.291 18.035h-18.655z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 20,
    className: "shard",
    d: "M212.52 760.498v68.206l5.337-68.206z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 21,
    className: "shard",
    d: "M-185.79 590.797l-5.336 68.207h23.987z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 22,
    className: "shard",
    d: "M720.2 548.104l22.704 18.035H720.2z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 23,
    className: "shard",
    d: "M-234.747 487.951l22.49-18.035v18.035z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 24,
    className: "shard",
    d: "M331.487-314.413h50.272l-27.568 18.035z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 25,
    className: "shard",
    d: "M695.454-60.194l3.687-18.037h18.802z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 26,
    className: "shard",
    d: "M549.196-186.744l10.65 20.837 16.918-38.871z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 27,
    className: "shard",
    d: "M789.664 317.308l-13.232 20.834 16.918-38.871z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 28,
    className: "shard",
    d: "M768.417 50.632l13.232 47.37V29.795z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 29,
    className: "shard",
    d: "M46.184-290.21l10.65 20.836-10.65 47.37z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 30,
    className: "shard",
    d: "M688.458 570.907l-10.65 47.37h23.882z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 31,
    className: "shard",
    d: "M-7.11-231.642l4.184 9.138-9.643 5.266z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 32,
    className: "shard",
    d: "M781.932 270.453l8.307 2.504-4.878-12.324z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 33,
    className: "shard",
    d: "M-205.011-4.95l3.319-7.794 5.477 10.323z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 34,
    className: "shard",
    d: "M706.434-125.784l1.491 11.568-25.56 13.918z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 35,
    className: "shard",
    d: "M13.54-264.105L-.884-243.886l24.07-25.485z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 36,
    className: "shard",
    d: "M-276.165 98.14l-4.314 11.01 18.737 11.592z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 37,
    className: "shard",
    d: "M579.037-168.978l25.56-13.918-11.137 36.517z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 38,
    className: "shard",
    d: "M-113.852 623.845l2.184 10.997 16.553.594z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 39,
    className: "shard",
    d: "M-290.649 255.732l4.658 18.21-14.16-18.554z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 40,
    className: "shard",
    d: "M-246.76 76.829l-5.186 7.115-7.858-8.173z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 41,
    className: "shard",
    d: "M-174.508 551.926l7.05.25-2.394 17.965z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 42,
    className: "shard",
    d: "M-252.11 183.034l2.395-17.96 10.65 19.022z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 43,
    className: "shard",
    d: "M632.083-123.544l8.89 10.035-20.026 26.484z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 44,
    className: "shard",
    d: "M-267.923 458.672l8.887 10.034-.585-7.532z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 45,
    className: "shard",
    d: "M-2.757 763.11l7.544-7.495-5.274-17.32z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 46,
    className: "shard",
    d: "M438.722 768.205l-12.92 5.796 10.65 19.022z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 47,
    className: "shard",
    d: "M721.342 46.423l7.106-20.691-20.026 26.487z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 48,
    className: "shard",
    d: "M158.28-282.088l11.21 11.486-2.416-8.96z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 49,
    className: "shard",
    d: "M702.242-13.46l18.316-9.201-11.212-11.488z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 50,
    className: "shard",
    d: "M-158.74-100.874l5.273 17.32 7.377-8.274z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 51,
    className: "shard",
    d: "M286.986-278.287l18.316-9.199-.534 8.165z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 52,
    className: "shard",
    d: "M193.304-277.327l12.65 9.046 5.131-10.078z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 53,
    className: "shard",
    d: "M724.193 531.815l23.992-29.46v29.46z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 54,
    className: "shard",
    d: "M625.998-175.317v35.227l23.991-17.192z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 55,
    className: "shard",
    d: "M-223.142-40.534v22.416l-23.992-5.222z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 56,
    className: "shard",
    d: "M814 361.528v17.934l-23.992-23.156z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 57,
    className: "shard",
    d: "M432.411-294.159v52.618l23.992-29.462z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 58,
    className: "shard",
    d: "M-255.35 374.682l20.025-17.934h-20.024z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 59,
    className: "shard",
    d: "M269.696 802.224l8.459-17.934-20.025 17.934z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 60,
    className: "shard",
    d: "M773.525 175.857l26.45-2.563-8.568 32.02z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 61,
    className: "shard",
    d: "M604.826 617.018l19.381 32.02H596.26z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 62,
    className: "shard",
    d: "M541.888-209.336l25.809-18.037h-49.798z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 63,
    className: "shard",
    d: "M744.388-17.383h20.022l5.782-18.037z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 64,
    className: "shard",
    d: "M378.763-269.027l17.99 15.369-26.449 2.563z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 65,
    className: "shard",
    d: "M155.647 793.023l3.9-.702 23.23 9.667z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 66,
    className: "shard",
    d: "M483.709 721.21l-2.212 4.34 18.374 13.098z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 67,
    className: "shard",
    d: "M551.22 667.264l4.799-3.454 18.374 13.098z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 68,
    className: "shard",
    d: "M754.05 453.16l27.075 8.941-9.082 6.432z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 69,
    className: "shard",
    d: "M456.534 765.881l21.656-13.346-15.875-4.691z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 70,
    className: "shard",
    d: "M-227.322 534.154l-7.926-3.31 21.658-13.347z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 71,
    className: "shard",
    d: "M573.618 726.881l3.13 5.838 10.603-22.494z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 72,
    className: "shard",
    d: "M340.304 796.532l23.858-1.585-24.003 6.355z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 73,
    className: "shard",
    d: "M669.927 631.13l7.572 6.944-18.175 15.551z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 74,
    className: "shard",
    d: "M526.419-287.893l3.726 6.493-21.899 9.058z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 75,
    className: "shard",
    d: "M505.704-210.74l1.96 7.471-23.859 1.585z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 76,
    className: "shard",
    d: "M729.073 452.256l-.093 7.865-23.91-1.51z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 77,
    className: "shard",
    d: "M501.62-233.217l4.948-7.022-21.113-10.416z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 78,
    className: "shard",
    d: "M130.452-289.688l2.797-8.904-23.912-1.51z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 79,
    className: "shard",
    d: "M-39.096 692.328l23.882 40.882.108-40.88z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 80,
    className: "shard",
    d: "M-295.93 354.904v26.257l23.882 14.622z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 81,
    className: "shard",
    d: "M637.247 602.159l6.21 10.622-18.702 13.117z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 82,
    className: "shard",
    d: "M-133.321 682.858l15.455 10.868 3.244-23.987z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 83,
    className: "shard",
    d: "M624.951 669.764l13.08 7.053-16.324 16.93z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 84,
    className: "shard",
    d: "M-91.789 673.654l21.207 3.844-4.883-20.774z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 85,
    className: "shard",
    d: "M-116.754-115.75l11.415-.36-6.533 21.137z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 86,
    className: "shard",
    d: "M-192.36 517.647l23.882 14.622-30.415 6.512z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 87,
    className: "shard",
    d: "M-42.825 711.723l-.093-13.464-24.46 11.891z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 88,
    className: "shard",
    d: "M-287.943 224.536l5.414-10.102-26.571-.993z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 89,
    className: "shard",
    d: "M-283.081 188.558l-26.572-.993 11.025-15.511z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 90,
    className: "shard",
    d: "M540.704 711.217l-9.583 6.753-15.546-16.502z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 91,
    className: "shard",
    d: "M-326.487 125.676l13.197-8.366 11.937 18.122z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 92,
    className: "shard",
    d: "M-265.152 51.678l13.646-1.561-25.583-16.56z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 93,
    className: "shard",
    d: "M-265.73 425.673l18.014-3.885 7.57 20.445z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 94,
    className: "shard",
    d: "M-191.93-46.349l22.534 24.905 11.245-18.463-33.776-6.442z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 95,
    className: "shard",
    d: "M-40.341-202.045l7.53 20.331 15.003 4.576z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 96,
    className: "shard",
    d: "M-310.343 314.726l4.026 13.44 20.532-11.867z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 97,
    className: "shard",
    d: "M-283.035 285.915l8.036 11.872 12.494-23.742z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 98,
    className: "shard",
    d: "M98.17-255.423l3.02-10.323 21.152 11.095z",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 99,
    className: "shard",
    d: "M220.54-322.65l-.288 12.668 24.46-11.893z",
    fill: "#aaa"
  }))));
};
export default SvgBase;